// import ssoImg1 from "./../../../../assets/images/708.png"; // Adjust the path as necessary
// import ssoImg2 from "./../../../../assets/images/283.png"; // Adjust the path as necessary
import img01 from "./../../../assets/images/283.png";// Adjust the path as necessary

function WelfareServices() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Seafarer Welfare
        <span className="text-orange-ef3e33 font-400"> Services</span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="text-primary-color mb-3">
            Services offered through the help desk (in person and virtually)
          </p>

          <p className="text-primary-color mb-3 font-600">
            Our key areas are :
          </p>

          <ul class="green-star-ul">
            <li>Attends to general crew complaints i.e. contractual disputes, living conditions, repatriation requests etc
            </li>
            <li>Medical Practitioner - Medical Practitioners must be accredited by SAMSA to conduct a medical examination for Seafarers. Only medical  fitness certificates provided by Accredited Medical Practitioners are  accepted.</li>
            
            <li>Guide families of deceased or seafarers lost at sea.</li>
                    <li>Complaints related to GBV, violence and harassment, including sexual harassment, bullying and sexual assault.         
            </li>
            <li>Provide counselling support to seafarers and their families in distress where possible as well as refer to relevant departments.         
            </li>
            <li>Awareness campaigns (mental health, substance abuse, know your rights etc)</li> 
          </ul>         
        </div>
        <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
          </div>          
        </div>
        
       
      </div>
    </>
  );
}

export default WelfareServices;